import $ from 'jquery'
import sponsorsSlider from "./sponsors-slider"

export default {
	init() {

		const $load_restavracije_wrapper = $("#izbor-okusov")
		const $load_restavracije_skeleton = $("#izbor-okusov .restaurant-skeleton")
		const $posts_wrapper = $("#izbor-okusov .more-posts")
		const $loadmore_button = $("#izbor-okusov .loadmore-category")
		const $search_input = $("#search")
		const $search_button = $("#search-btn")
		const $more_wrapper = $("#izbor-okusov .more-wrapper")
		let loaded_post_ids = [] // a list with current visible restaurant IDs
		let page = 1
		let activeRequest = null
		let requestSerial = 0
		// Filter prostih terminov (TR) — deklarirano tu, ker setFiltersFromCookie() teče že ob inicializaciji
		const PROSTI_TERMINI_GROUPS = ["prosto_oseb", "prosti_dan", "prosta_ura"]
		let suppressReload = false

		if ($load_restavracije_wrapper.length > 0) {
			//  Initial loading of posts
			let loaded_post_element = $("#loaded_post_ids")

			if (loaded_post_element.length) {
				if (loaded_post_element.val() != "") {
					loaded_post_ids = loaded_post_element.val().split(",") // prepare visible restaurant ID lis
				}
			}


			// get values from cookie restavracijefilter
			let cookie = document.cookie.match(/restavracijefilter=([^;]+)/)
			let filterValuesCookie = cookie ? JSON.parse(cookie[1]) : false
			if (filterValuesCookie != false) {
				setFiltersFromCookie(filterValuesCookie)
			}

			// initial load
			loadRestavracije()

			// Load More button trigger
			$loadmore_button.on('click', function (e) {
				e.preventDefault()
				loadRestavracije(true)
			})

			// Change Filters
			// (prosto_oseb / prosti_dan / prosta_ura / prikazi_zasedene = filter prostih terminov TR, template-parts/home/filter-prosti-termini.php)
			$("input[type=radio][name=pokrajina], input[name=ocena], input[name=zelje], input[name=znacke], select[name=order_select], input[name=prosto_oseb], input[name=prosti_dan], input[name=prosta_ura], input[name=prikazi_zasedene]").on('change', function () {
				if (suppressReload) return // programska ponastavitev (iskanje) — naloži samo enkrat
				page = 1
				loaded_post_ids = []

				// return Load more pages button
				$more_wrapper.css({ visibility: "visible" })
				$search_input.val("")

				loadRestavracije()
			})
		}

		$search_input.on("keydown", debounce(function (e) {
			if (e.key == "Enter") {
				$search_button.trigger("click")
			}
		}, 500))
		

		$search_button.on('click', function (e) {
			let search = $search_input.val()
			// if (search == "") {
			// 	$search_input.focus()
			// 	return
			// }

			$(this).prop("disabled", true)

			if ($load_restavracije_wrapper.length == 0) {
				redirectToHome(search)
				return
			}

			page = 1
			loaded_post_ids = []

			// Reset regija radio
			$("input[type=radio][name=pokrajina]:checked").prop("checked", false)
			$("input[type=radio][name=pokrajina]#pokrajina-all").prop("checked",true)

			// Reset ocena (checkboxi — brez izbire = vse ocene)
			$("input[name=ocena]:checked").prop("checked", false)

			// Reset zelje
			$("input[name=zelje]:checked").prop("checked", false)

			// Značke zelje
			$("input[name=znacke]:checked").prop("checked", false)

			// Prosti termini (TR): nazaj na "vsi"
			resetProstiTermini()

			// return Load more pages button
			$more_wrapper.css({ visibility: "visible" })

			loadRestavracije()

			//scroll to #izbor-okusov
			document.getElementById("izbor-okusov").scrollIntoView({ behavior: "smooth" })
		})


		// Set filters from cookie
		function setFiltersFromCookie(filterValuesCookie) {

			// console.log(filterValuesCookie)

			$("input[type=radio][name=pokrajina]").each(function () {
				if (this.value == filterValuesCookie.pokrajina) {
					this.checked = true
				}
			})

			// ocena je seznam (checkboxi); stari piškotek je lahko še niz
			const ocenaCookie = Array.isArray(filterValuesCookie.ocena) ? filterValuesCookie.ocena : [filterValuesCookie.ocena]
			$("input[name=ocena]").each(function () {
				if (ocenaCookie.includes(this.value)) {
					this.checked = true
				}
			})

			$("input[name=zelje]").each(function () {
				if (filterValuesCookie.zelje && filterValuesCookie.zelje.includes(this.value)) {
					this.checked = true
				}
			})

			$("input[name=znacke]").each(function () {
				if (filterValuesCookie.znacke && filterValuesCookie.znacke.includes(this.value)) {
					this.checked = true
				}
			})

			PROSTI_TERMINI_GROUPS.forEach(function (name) {
				const value = filterValuesCookie[name]
				if (!value || value === "all") return
				$("input[name='" + name + "'][value='" + value + "']").prop("checked", true).trigger("change")
			})
			if (filterValuesCookie.prikazi_zasedene === "1") {
				$("input[name='prikazi_zasedene']").prop("checked", true).trigger("change")
			}

			$search_input.val(filterValuesCookie.search)

			$("select[name=order_select]").val(filterValuesCookie.order_select)
		}


		// Filter prostih terminov: radio skupine so na strani samo v TR pogledu, zato vedno z varovalko.
		function getProstiTerminiValue(name) {
			const checked = $("input[name='" + name + "']:checked")
			return checked.length ? checked.val() : "all"
		}

		// Checkbox "Prikaži tudi zasedene restavracije" (čakalna lista): "1" / "0"; brez checkboxa (ni TR pogled) "0".
		function getPrikaziZasedene() {
			return $("input[name='prikazi_zasedene']").is(":checked") ? "1" : "0"
		}

		function resetProstiTermini() {
			suppressReload = true
			PROSTI_TERMINI_GROUPS.forEach(function (name) {
				const $all = $("input[name='" + name + "'][value='all']")
				if ($all.length && !$all.prop("checked")) {
					// 'change' obvesti mobilni panel (chipi), nalaganje je med tem izklopljeno
					$all.prop("checked", true).trigger("change")
				}
			})
			const $zasedene = $("input[name='prikazi_zasedene']")
			if ($zasedene.prop("checked")) {
				$zasedene.prop("checked", false).trigger("change")
			}
			suppressReload = false
		}

		function redirectToHome(searchString) {
			window.location.href = "/?iskanje=" + searchString
		}

		// Število stolpcev v gridu iz izračunanega grid-template-columns.
		// Skeleton ima iste grid razrede kot .more-posts in je med nalaganjem
		// vedno display:grid, zato ni treba podvajati breakpointov v JS.
		// Backend iz tega izračuna posts_per_page (polne vrste) in položaj sponzorjev.
		function getGridColumns() {
			const candidates = [$load_restavracije_skeleton[0], $posts_wrapper[0]]
			for (const el of candidates) {
				if (!el) continue
				const style = window.getComputedStyle(el)
				if (style.display !== "grid") continue
				const cols = style.gridTemplateColumns.split(" ").filter(Boolean).length
				if (cols > 0) return cols
			}
			return 4
		}
		
		function loadRestavracije(loadmore = false) {
			let filterValues = getFilterValues()
			const countSpan = $("#res-count")
			countSpan.hide()

			const requestedPage = loadmore ? page + 1 : 1

			if (!loadmore) {
				//skeleton
				$load_restavracije_skeleton.addClass("grid").show()
				$posts_wrapper.removeClass("grid").addClass("hidden")
			}

			const requestId = ++requestSerial
			if (activeRequest) {
				activeRequest.abort()
			}

			const data = {
				page: requestedPage,
				loaded_post_ids: loaded_post_ids,
				columns: getGridColumns(),
				pokrajina: filterValues.pokrajina,
				ocena: filterValues.ocena,
				search: filterValues.search,
				zelje: filterValues.zelje,
				znacke: filterValues.znacke,
				order_select: filterValues.order_select,
				language: filterValues.language,
				prosto_oseb: filterValues.prosto_oseb,
				prosti_dan: filterValues.prosti_dan,
				prosta_ura: filterValues.prosta_ura,
				prikazi_zasedene: filterValues.prikazi_zasedene,
				// tr: tr ? "1" : "0",
			}


			activeRequest = $.ajax({
				url: '/wp-json/vivi/v1/restavracije',
				method: 'POST',
				data: data,
				beforeSend: function (xhr) {
					// prijavljen uporabnik: REST naj pozna uporabnika (admin TR stikalo)
					if (window.my_ajax_object && my_ajax_object.rest_nonce) {
						xhr.setRequestHeader("X-WP-Nonce", my_ajax_object.rest_nonce)
					}
					// Load more button
					if($loadmore_button.length > 0) {
						$loadmore_button.prop("disabled", true).text(loading_text)
					}
				},
				success: function (response) {

					if (requestId === requestSerial && response) {
						if (loadmore) {
							$posts_wrapper.append(response.content)
						} else {
							$posts_wrapper.html(response.content)
							
							//skeleton
							$load_restavracije_skeleton.hide()
							$posts_wrapper.removeClass("hidden").addClass("grid")
						}

						sponsorsSlider.init()

						page = requestedPage
						loaded_post_ids = Array.isArray(response.loaded_post_ids) ? response.loaded_post_ids : []

						const hasMore = typeof response.has_more === "boolean"
							? response.has_more
							: response.total_posts_count > response.current_count
						$more_wrapper.css({ visibility: hasMore ? "visible" : "hidden" })
						
						// Update Counter
						if(countSpan.length) {
							countSpan.text("(" + response.total_posts_count + ")").show()
						}

						// set cookie with filter values
						setFilterCookie(filterValues)

					}
				},
				error: function (xhr, status) {
					if (requestId !== requestSerial || status === "abort") {
						return
					}

					$load_restavracije_skeleton.hide()
					$posts_wrapper.removeClass("hidden").addClass("grid")
					console.error("Restaurants could not be loaded.", status)
				},
				complete: function () {
					if (requestId !== requestSerial) {
						return
					}

					activeRequest = null
					$search_button.prop("disabled", false)
					$loadmore_button.prop("disabled", false).text(loading_more_text_simple)
				}
			})
		}


		// Stanje filtrov velja 1 dan (prej sejni piškotek brez poteka): stara izbira prostih terminov
		// (dan/ura) se sicer prenaša v Order & Pay povezavo "Rezerviraj" (tr-rezervacija-link-params.js).
		function setFilterCookie(filterValues) {
			let cookie = "restavracijefilter=" + JSON.stringify(filterValues) + "; path=/; max-age=" + (24 * 60 * 60) + "; SameSite=Lax"
			document.cookie = cookie
		}

		function getFilterValues() {
			let language = document.documentElement.lang || "sl-SI"

			switch (language) {
				case "en-US":
					language = 'en';
					break;
					
				default:
					language = 'si';
					break;
			}

			let pokrajina = $("input[name='pokrajina']:checked")[0].value
			let ocena = $("input[name='ocena']:checked").map(function () {
				return this.value
			}).get()
			let search = $search_input.val()
			let order_select = $("select[name='order_select']").val()
			let zelje = $("input[name='zelje']:checked").map(function () {
				return this.value
			}).get()
			let znacke = $("input[name='znacke']:checked").map(function () {
				return this.value
			}).get()
        
            return {
                'language': language,
                'pokrajina': pokrajina, 
                'ocena': ocena,
                'search': search,
                'zelje': zelje,
                'znacke': znacke,
                'order_select': order_select,
                'prosto_oseb': getProstiTerminiValue("prosto_oseb"),
                'prosti_dan': getProstiTerminiValue("prosti_dan"),
                'prosta_ura': getProstiTerminiValue("prosta_ura"),
                'prikazi_zasedene': getPrikaziZasedene()
            }
		}

		function debounce(func, wait) {
			let timeout
			return function (...args) {
				const context = this
				clearTimeout(timeout)
				timeout = setTimeout(() => func.apply(context, args), wait)
			}
		}
		
	}
}
